<template>
	<section v-if="loading" :class="['filters', section]">
		<div class="empty">
			<font-awesome-icon icon="fa-spinner" class="icon fa-spin" />
		</div>
	</section>

	<section v-else :class="['filters', section]">

		<template v-if="section != 'dashboard'">
			<div class="title">Department</div>
			<select v-model="filters.department_id" :class="[section, filters.department_id ? '' : 'empty-input']" @change="goToDepartment()">
				<option value=''>Select...</option>
				<optgroup label="Firearms">
					<option v-for="(department, key) in departments.firearms" :value="department.department_id">{{ department.description }}</option>
				</optgroup>
				<optgroup label="Accessories">
					<option v-for="(department, key) in departments.non_firearms" :value="department.department_id">{{ department.description }}</option>
				</optgroup>
				<optgroup v-if="section == 'sales'" label="Non-Inventory">
					<option v-for="(department, key) in departments.non_inventory" :value="department.department_id">{{ department.description }}</option>
				</optgroup>
			</select>
			<div class="divider"></div>
		</template>

		<template v-if="section != 'dashboard' && filters.department_id">
			<div class="title">Category</div>
			<select v-model="filters.category_id" :class="[section, filters.category_id ? '' : 'empty-input']" @change="goToCategory()">
				<option value=''>Select...</option>
				<option v-for="(category, key) in categories" :value="category.category_id">{{ category.description }}</option>
			</select>
			<div class="divider"></div>
		</template>

		<template v-if="section != 'dashboard' && filters.department_id && showCalibers">
			<div class="title">Caliber</div>
			<select v-model="filters.caliber_id" :class="[section, filters.caliber_id ? '' : 'empty-input']" @change="goToCaliber()">
				<option value=''>Select...</option>
				<option v-for="(caliber, key) in calibers" :value="caliber.caliber_id">{{ caliber.description }}</option>
			</select>
			<div class="divider"></div>
		</template>

		<template v-if="section == 'received' && getApiUserType != 'MANUFACTURER'">
			<div class="title">Supplier</div>
			<input type="search" v-model="filters.supplier_search_text" placeholder="Search..." :class="[section, filters.supplier_search_text ? '' : 'empty-input']" @search="doSupplierSearch()" />
			<div class="divider"></div>
		</template>

		<template v-if="section == 'manufacturers'">
			<div class="title">Manufacturer</div>
			<input type="search" v-model="filters.manufacturer_search_text" placeholder="Search..." :class="[section, filters.manufacturer_search_text ? '' : 'empty-input']" @search="doManufacturerSearch()" />
			<div class="divider"></div>
		</template>

		<div class="title">Year</div>
		<select v-model="filters.report_year" class="section" @change="setReportYear()">
			<option v-for="(year, index) in years" :value="year.code">{{ year.description }}</option>
		</select>

		<div class="title">Period</div>
		<select v-model="filters.period" :class="[section, filters.period ? '' : 'empty-input']" @change="setReportPeriod()">
			<option value="">Select...</option>
			<optgroup label="Quarter">
				<option v-for="(quarter, index) in quarters" :value="quarter.code" :disabled="filters.report_year == getThisYear() ? getThisQuarter() < index + 1 : false">{{ quarter.description }}</option>
			</optgroup>
			<optgroup label="Month">
				<option v-for="(month, index) in months" :value="month.code" :disabled="filters.report_year == getThisYear() ? getThisMonth() < month.code : false">{{ month.description }}</option>
			</optgroup>
		</select>

		<div class="input-with-control" style="margin: 0 0 1em 0;">
			<div class="title" style="padding: 0.5em 0 0 0;">Dates</div>
			<font-awesome-icon icon="fa-calendar" class="icon" @click="showDatePickers = true" />
		</div>

		<template v-if="section != 'dashboard'">
			<div :class="['button', section]" @click="setCompareDates()">{{ filters.compare ? 'Exit Compare' : 'Compare' }}</div>
		</template>

		<div class="divider"></div>
		<div :class="['button', hasFilters ? 'neutral' : 'disabled']" @click="clearFilters()">Clear Filters</div>

		<template v-if="!loadingData && section != 'distributors'">
			<div class="divider"></div>
			<div class="title">Data Basis<font-awesome-icon icon="fa-info-circle" class="icon" @click="showBasisModal = !showBasisModal" /></div>
			<div><input type="radio" name="basis" value="actual" v-model="filters.basis" @click="setReportBasis()"> Actual</div>
			<div><input type="radio" name="basis" value="industry" v-model="filters.basis" @click="setReportBasis()"> Industry</div>
		</template>

		<div class="divider"></div>
		<div class="title">Product Search</div>
		<input type="search" v-model="filters.search_text" placeholder="UPC..." :class="['inventory', filters.search_text ? '' : 'empty-input']" @search="doProductSearch()" />

		<!-- <div v-if="getApiUserType == 'SUPERADMIN'">
			<div class="divider"></div>
			<input type="checkbox" v-model="filters.mask_dealers" @click="setMaskDealers()" /> Mask Dealers
		</div> -->

		<div v-if="showExportButton">
			<div class="divider"></div>
			<div class="button neutral" @click="exportList()">Export List</div>
		</div>

		<div v-if="showDatePickers" :class="['modal', section]">
			<div class="inner">
				<h2>Select Report Dates</h2>
				<div class="content two-columns">
					<label>Start</label>
					<label>End</label>
					<input type="date" :min="filters.report_year + '-01-01'" :max="filters.report_year == getThisYear() ? maxDBDate : filters.report_year + '-12-31'" v-model="filters.start_date" :class="filters.start_date ? '' : 'empty-input'" />
					<input type="date" :min="filters.report_year + '-01-01'" :max="filters.report_year == getThisYear() ? maxDBDate : filters.report_year + '-12-31'" v-model="filters.end_date" :class="filters.end_date ? '' : 'empty-input'" />
				</div>
				<div class="controls">
					<div class="button cancel" @click="cancelReportDates()">Cancel</div>
					<div :class="['button', filters.start_date && filters.end_date ? section : 'disabled']" @click="applyReportDates()">Apply</div>
				</div>
			</div>
		</div>

		<div v-if="showSupplierSearch" class="modal">
			<div class="inner">
				<h2>Searching Suppliers</h2>
				<div class="content">
					<p class="center">Searching for <b>{{ filters.supplier_search_text }}</b>...</p>
					<p v-if="!message" class="loading"><font-awesome-icon icon="fa-spinner" class="icon fa-spin" /></p>
					<div v-if="searchList.length > 1" class="modal-search-result">
						<table class="list">
							<tr v-for="(supplier, index) in searchList" :class="supplier.locked ? 'disabled' : 'clickable'" @click="goToSupplier(supplier)">
								<td class="left">{{ supplier.company_name }}</td>
							</tr>
						</table>
					</div>
				</div>
				<p v-if="message" class="note">{{ message }}</p>
				<div class="controls">
					<div class="button cancel" @click="showSupplierSearch = false">Cancel</div>
				</div>
			</div>
		</div>

		<div v-if="showManufacturerSearch" class="modal">
			<div class="inner">
				<h2>Searching Manufacturers</h2>
				<div class="content">
					<p class="center">Searching for <b>{{ filters.manufacturer_search_text }}</b>...</p>
					<p v-if="!message" class="loading"><font-awesome-icon icon="fa-spinner" class="icon fa-spin" /></p>
					<div v-if="searchList.length > 1" class="modal-search-result">
						<table class="list">
							<tr v-for="(manufacturer, index) in searchList" class="clickable" @click="goToManufacturer(manufacturer)">
								<td class="left">{{ manufacturer.description }}</td>
							</tr>
						</table>
					</div>
				</div>
				<p v-if="message" class="note">{{ message }}</p>
				<div class="controls">
					<div class="button cancel" @click="showManufacturerSearch = false">Cancel</div>
				</div>
			</div>
		</div>

		<div v-if="showProductSearch" class="modal">
			<div class="inner">
				<h2>Searching Products</h2>
				<div class="content">
					<p class="center">Searching for UPC <b>{{ filters.search_text }}</b>...</p>
					<p v-if="!message" class="loading"><font-awesome-icon icon="fa-spinner" class="icon fa-spin" /></p>
					<div v-if="searchList.length > 1" class="modal-search-result">
						<table class="list">
							<tr v-for="(product, index) in searchList" class="clickable" @click="goToProduct(product)">
								<td class="center">
									<div class="image-wrapper-small">
										<img :src="product.image_src" />
									</div>
								</td>
								<td class="left">{{ product.description }}</td>
							</tr>
						</table>
					</div>
				</div>
				<p v-if="message" class="note">{{ message }}</p>
				<div class="controls">
					<div class="button cancel" @click="showProductSearch = false">Cancel</div>
				</div>
			</div>
		</div>

		<div v-if="showComparePickers" :class="['modal', section]">
			<div class="inner">
				<h2>Compare {{ compareLabel }}</h2>
				<div class="content">
					<p>Compare {{ compareLabel }} with...</p>

					<div v-if="filters.period == 'dates'">
						Show date pickers!
					</div>
					
					<div v-else-if="filters.period.indexOf('_quarter') > -1" class="two-columns">
						<p>
							<label>Quarter...</label>
							<select :class="section" v-model="filters.compare_period">
								<option value=''>Select...</option>
								<option v-for="(quarter, index) in quarters" :value="quarter.code">{{ quarter.description }}</option>
							</select>
						</p>
						<p>
							<label>Year</label>
							<select :class="section" v-model="filters.compare_year">
								<option value=''>Select...</option>
								<option v-for="(year, index) in years" :value="year.code" :disabled="year.code < 2023">{{ year.description }}</option>
							</select>
						</p>
					</div>

					<div v-else-if="filters.period" class="two-columns">
						<p>
							<label>Month...</label>
							<select :class="section" v-model="filters.compare_period">
								<option value=''>Select...</option>
								<option v-for="(month, index) in months" :value="month.code">{{ month.description }}</option>
							</select>
						</p>
						<p>
							<label>Year</label>
							<select :class="section" v-model="filters.compare_year">
								<option value=''>Select...</option>
								<option v-for="(year, index) in years" :value="year.code" :disabled="year.code < 2023">{{ year.description }}</option>
							</select>
						</p>
					</div>

					<div v-else>
						<select :class="section" v-model="filters.compare_year">
							<option value=''>Select...</option>
							<option v-for="(year, index) in years" :value="year.code" :disabled="year.code == filters.report_year || year.code < '2023'">{{ year.description }}</option>
						</select>
					</div>

				</div>
				<p v-if="message" class="note">{{ message }}</p>
				<div class="controls">
					<div class="button cancel" @click="showComparePickers = false">Cancel</div>
					<div :class="['button', filters.compare_period || filters.compare_year ? section : 'disabled']" @click="applyCompare()">Apply</div>
				</div>
			</div>
		</div>

		<div v-if="showBasisModal" :class="['modal', section]">
			<div class="inner">
				<h2>Data Basis</h2>
				<div class="content">
					<p>Actual Data Basis is the true inventory, sales and purchasing data from {{ getReportingDealers }} participating dealers and distributors.</p>
					<p>Industry Data Basis is Actual Data extrapolated with known industry data and gives estimated industry totals.</p>
				</div>
				<div class="controls">
					<div class="button cancel" @click="showBasisModal = false">Got It</div>
				</div>
			</div>
		</div>

	</section>
</template>

<script>
	export default {
		name: 'filters',
		props: ['section', 'loadingData'],
		data () {
			return {
				loading: true,
				loadingDepartments: false,
				message: '',
				filters: {},
				maxDBDate: '',
				startDate: '',
				endDate: '',
				numberOfDays: '',
				showDatePickers: false,
				departments: {},
				categories: [],
				calibers: [],
				loadingCategories: false,
				loadingCalibers: false,
				showComparePickers: false,
				comparePeriod: '',
				showProductSearch: false,
				showSupplierSearch: false,
				showManufacturerSearch: false,
				searchList: [],
				searching: false,
				showBasisModal: false,
				years: [
					{ code: '2026', description: '2026'},
					{ code: '2025', description: '2025'},
					{ code: '2024', description: '2024'},
					{ code: '2023', description: '2023'}
				],
				quarters: [
					{ code: 'first_quarter', description: 'First Quarter'},
					{ code: 'second_quarter', description: 'Second Quarter'},
					{ code: 'third_quarter', description: 'Third Quarter'},
					{ code: 'fourth_quarter', description: 'Fourth Quarter'}
				],
				months: [
					{ code: '01', description: 'January'},
					{ code: '02', description: 'February'},
					{ code: '03', description: 'March'},
					{ code: '04', description: 'April'},
					{ code: '05', description: 'May'},
					{ code: '06', description: 'June'},
					{ code: '07', description: 'July'},
					{ code: '08', description: 'August'},
					{ code: '09', description: 'September'},
					{ code: '10', description: 'October'},
					{ code: '11', description: 'November'},
					{ code: '12', description: 'December'}
				]
			}
		},
		created() {
			if (sessionStorage.getItem('filters') != null) {
				this.filters = JSON.parse(sessionStorage.getItem('filters'))
			} else {
				this.clearFilters(true)
			}
			if (Object.keys(this.getStateDepartments).length > 0) {
				this.departments = this.getStateDepartments
				this.loading = false
			} else {
				this.getDepartments()
			}
			if (this.filters.department_id) {
				if (this.getStateFilters.department_id != this.filters.department_id) {
					this.getCategories()
				} else if (this.getStateCategories.length > 0) {
					this.categories = this.getStateCategories
				} else {
					this.getCategories()
				}
			}
			if (this.filters.category_id) {
				if (this.getStateFilters.category_id != this.filters.category_id) {
					this.getCalibers()
				} else if (this.getStateCalibers.length > 0) {
					this.calibers = this.getStateCalibers
				} else {
					this.getCalibers()
				} 
			} else if (this.filters.department_id) {
				if (this.getStateFilters.department_id != this.filters.department_id) {
					this.getCalibers()
				} else if (this.getStateCalibers.length > 0) {
					this.calibers = this.getStateCalibers
				} else {
					this.getCalibers()
				} 
			}
			this.updateStateFilters(JSON.parse(JSON.stringify(this.filters)))
		},
		computed: {
			hasFilters() {
				return this.filters.department_id || this.filters.category_id || this.filters.caliber_id || this.filters.supplier_id || this.filters.manufacturer_id || this.filters.period || this.filters.start_date || this.filters.end_date
			},
			compareLabel() {
				if (this.filters.period == 'dates') {
					return 'Date Range'
				} else if (this.filters.period.indexOf('_quarter') > -1) {
					return this.capitalizeWords(this.filters.period) + ' ' + this.filters.report_year
				} else if (this.filters.period) {
					let periodName = ''
					this.months.forEach(item => {
						if (item.code == this.filters.period) {
							periodName = item.description
						}
					})
					return periodName + ' ' + this.filters.report_year
				} else {
					return (this.filters.report_year == this.getThisYear() ? 'YTD ' : 'Full Year ')  + this.filters.report_year
				}
			},
			showCalibers() {
				let departmentsWithCalibers = ['Rifles', 'Handguns', 'Shotguns', 'NFA / Class III', 'Law Enforcement', 'Magazines', 'Ammo']
				return departmentsWithCalibers.includes(this.filters.department_name)
			},
			showExportButton() {
				if (this.loadingData) { return false }
				if (this.section == 'sales' && this.filters.department_id) { return true }
				if (this.section == 'inventory' && this.filters.department_id) { return true }
				if (this.section == 'received') { return true }
				if (this.section == 'warehouse' && this.filters.distributor_id) { return true }
				if (this.section == 'distributors' && this.filters.distributor_id) { return true }
				if (this.section == 'manufacturers') { return true }
				return false
			}
		},
		methods: {
			getDepartments() {
				if (this.loadingDepartments) { return }
				this.loadingDepartments = true
				this.apiCall({ destination: 'get_departments', data: { section: this.section } }).then(obj => {
					this.loadingDepartments = false
					this.loading = false
					if (obj.status == 'success') {
						this.departments = obj.departments
					}
				}).catch(err => {
					console.log(err)
				})
			},
			clearFilters(forceClear) {
				if (!this.hasFilters && !forceClear) { return }
				this.filters = {
					department_id: '',
					department_name: '',
					category_id: '',
					category_name: '',
					caliber_id: '',
					caliber_name: '',
					supplier_id: '',
					supplier_name: '',
					manufacturer_id: '',
					manufacturer_name: '',
					distributor_id: '',
					distributor_name: '',
					page: 1,
					search_text: '',
					report_year: this.getThisYear(),
					period: '',
					compare: false,
					compare_period: '',
					compare_year: '',
					start_date: '',
					end_date: '',
					basis: 'actual',
					sort_column: '',
					sort_order: 'desc',
					mask_dealers: ''
				}
				sessionStorage.setItem('filters', JSON.stringify(this.filters));
				this.$emit('updateFilter', 'clear')
			},
			goToDepartment() {
				if (this.filters.department_id) {
					// we want to instantly update the department name so the user knows we got the message to change departments
					Object.entries(this.departments.firearms).forEach(([key, value]) => {
						if (value.department_id == this.filters.department_id) { this.filters.department_name = value.description }
					})
					if (!this.departmentName) {
						Object.entries(this.departments.non_firearms).forEach(([key, value]) => {
							if (value.department_id == this.filters.department_id) { this.filters.department_name = value.description }
						})
					}
				} else {
					this.filters.department_name = ''
				}
				this.categories = []
				this.calibers = []
				this.filters.category_id = ''
				this.filters.category_name = ''
				this.filters.caliber_name = '';
				this.filters.caliber_id = ''
				sessionStorage.setItem('filters', JSON.stringify(this.filters));
				this.$emit('updateFilter', 'department')
			},
			getCategories() {
				if (this.loadingCategories) { return }
				this.categories = []
				this.loadingCategories = true
				this.apiCall({ destination: 'get_categories', data: this.filters }).then(obj => {
					this.loadingCategories = false
					if (obj.status == 'success') {
						this.categories = obj.categories
					}
				}).catch(err => {
					console.log(err)
				})
			},
			goToCategory() {
				if (this.filters.category_id) {
					this.categories.forEach(category => {
						if (category.category_id == this.filters.category_id) {
							this.filters.category_name = category.description
						}
					})
				} else {
					this.filters.category_name = ''
					this.calibers = []
				}
				this.filters.caliber_name = '';
				this.filters.caliber_id = ''
				sessionStorage.setItem('filters', JSON.stringify(this.filters));
				this.$emit('updateFilter', 'category')
			},
			getCalibers() {
				if (this.loadingCalibers) { return }
				if (!this.showCalibers) { return }
				this.calibers = []
				this.loadingCalibers = true
				this.apiCall({ destination: 'get_calibers', data: this.filters }).then(obj => {
					this.loadingCalibers = false
					if (obj.status == 'success') {
						this.calibers = obj.calibers
					}
				}).catch(err => {
					console.log(err)
				})
			},
			goToCaliber() {
				if (this.filters.caliber_id) {
					this.calibers.forEach(caliber => {
						if (caliber.caliber_id == this.filters.caliber_id) {
							this.filters.caliber_name = caliber.description
						}
					})
				} else {
					this.filters.caliber_name = ''
				}
				sessionStorage.setItem('filters', JSON.stringify(this.filters));
				this.$emit('updateFilter', 'caliber')
			},
			setReportYear() {
				this.filters.compare = false
				this.filters.start_date = ''
				this.filters.end_date = ''
				sessionStorage.setItem('filters', JSON.stringify(this.filters));
				this.$emit('updateFilter', 'year')
			},
			setReportPeriod() {
				this.filters.compare = false
				this.filters.start_date = ''
				this.filters.end_date = ''
				this.filters.period_name = ''
				if (this.filters.period) {
					this.quarters.forEach(item => {
						if (item.code == this.filters.period) {
							this.filters.period_name = item.description
						}
					})
					this.months.forEach(item => {
						if (item.code == this.filters.period) {
							this.filters.period_name = item.description
						}
					})
				}
				sessionStorage.setItem('filters', JSON.stringify(this.filters));
				this.$emit('updateFilter', 'period')
			},
			applyReportDates() {
				if (!this.filters.start_date || !this.filters.end_date) { return }
				this.filters.compare = false
				this.filters.period = ''
				this.filters.period_name = 'custom dates'
				this.showDatePickers = false
				sessionStorage.setItem('filters', JSON.stringify(this.filters));
				this.$emit('updateFilter', 'dates')
			},
			cancelReportDates() {
				this.showDatePickers = false
			},
			setCompareDates() {
				if (this.filters.compare) {
					this.filters.compare = false
					sessionStorage.setItem('filters', JSON.stringify(this.filters));
					this.$emit('updateFilter', 'compare')
					return
				}
				this.message = ''
				this.filters.compare_period = ''
				this.filters.compare_year = ''
				this.showComparePickers = true
			},
			applyCompare() {
				this.message = ''
				if (!this.filters.period && !this.filters.compare_year) {
					this.message = 'Please select a year to compare.'
					return
				}
				if (this.filters.period && (!this.filters.compare_period || !this.filters.compare_year)) {
					if (this.filters.period.indexOf('_quarter') > -1) {
						this.message = 'Please select a quarter and year to compare.'
					} else {
						this.message = 'Please select a period and year to compare.'
					}
					return
				}
				this.showComparePickers = false
				this.filters.compare = true
				sessionStorage.setItem('filters', JSON.stringify(this.filters));
				this.$emit('updateFilter', 'compare')
			},
			doSupplierSearch() {
				if (!this.filters.supplier_search_text || this.searching) { return }
				this.message = ''
				this.searchList = []
				this.showSupplierSearch = true
				this.showComparePickers = false
				this.searching = true
				this.apiCall({ destination: 'search_suppliers', data: { search_text: this.filters.supplier_search_text } }).then(obj => {
					this.searching = false
					if (obj.status == 'success') {
						if (obj.suppliers.length == 1) {
							this.goToSupplier(obj.suppliers[0])
						} else if (obj.suppliers.length == 0) {
							this.message = 'No suppliers found.'
						} else {
							this.searchList = obj.suppliers
							this.message = 'More than one supplier found.'
						}
					}
				}).catch(err => {
					console.log(err)
				})
			},
			goToSupplier(supplier) {
				this.showSupplierSearch = false
				if (supplier.locked) { return }
				this.filters.supplier_search_text = supplier.company_name
				this.filters.supplier_id = supplier.supplier_id
				this.filters.supplier_name = supplier.company_name
				this.filters.page = 1
				this.filters.product_page = 1
				this.filters.compare = false
				sessionStorage.setItem('filters', JSON.stringify(this.filters));
				this.$emit('updateFilter', 'supplier')
			},
			doManufacturerSearch() {
				if (!this.filters.manufacturer_search_text || this.searching) { return }
				this.message = ''
				this.searchList = []
				this.showManufacturerSearch = true
				this.showComparePickers = false
				this.searching = true
				this.apiCall({ destination: 'search_manufacturers', data: { search_text: this.filters.manufacturer_search_text } }).then(obj => {
					this.searching = false
					if (obj.status == 'success') {
						if (obj.manufacturers.length == 1) {
							this.goToManufacturer(obj.manufacturers[0])
						} else if (obj.manufacturers.length == 0) {
							this.message = 'No manufacturers found.'
						} else {
							this.searchList = obj.manufacturers
							this.message = 'More than one manufacturer found.'
						}
					}
				}).catch(err => {
					console.log(err)
				})
			},
			goToManufacturer(manufacturer) {
				this.showManufacturerSearch = false
				this.filters.manufacturer_search_text = manufacturer.description
				this.filters.manufacturer_id = manufacturer.manufacturer_id
				this.filters.manufacturer_name = manufacturer.description
				this.filters.page = 1
				this.filters.product_page = 1
				this.filters.compare = false
				sessionStorage.setItem('filters', JSON.stringify(this.filters));
				this.$emit('updateFilter', 'manufacturer')
			},
			doProductSearch() {
				if (!this.filters.search_text || this.searching) { return }
				this.message = ''
				this.searchList = []
				this.showProductSearch = true
				this.showComparePickers = false
				if (this.filters.search_text.length < 12) {
					this.message = 'Please enter at least 12 digits.'
					return
				}
				let isDigits = /^\d+$/.test(this.filters.search_text)
				if (!isDigits) {
					this.message = 'Please enter a valid UPC.'
					return
				}
				this.searching = true
				this.apiCall({ destination: 'search_products', data: { upc: this.filters.search_text } }).then(obj => {
					this.searching = false
					if (obj.status == 'success') {
						if (obj.products.length == 1) {
							this.showProductSearch = false
							this.goToProduct(obj.products[0])
						} else if (obj.products.length == 0) {
							this.message = 'No products found.'
						} else {
							this.searchList = obj.products
							this.message = 'More than one product found.'
						}
					}
				}).catch(err => {
					console.log(err)
				})
			},
			goToProduct(product) {
				this.filters.product_id = product.product_id
				this.filters.search_text = ''
				this.showProductSearch = false
				sessionStorage.setItem('filters', JSON.stringify(this.filters));
				this.$emit('updateFilter', 'product')
			},
			setReportBasis() {
				// slight delay while the dom input updates
				setTimeout(() => {
					this.filters.compare = false
					sessionStorage.setItem('filters', JSON.stringify(this.filters));
					this.$emit('updateFilter', 'basis')
				}, 100)
			},
			setMaskDealers() {
				// slight delay while the dom input updates
				setTimeout(() => {
					if (!this.filters.mask_dealers) {
						delete this.filters.mask_dealers
					}
					sessionStorage.setItem('filters', JSON.stringify(this.filters));
				}, 100)
			},
			exportList() {
				this.$emit('exportList')
			}
		}
	}
</script>
